import React from 'react';
import { PageText } from '../styles';
var MagazineText = function (_a) {
    var post = _a.post;
    return React.createElement(PageText, { type: post.style }, post.text);
};
export default MagazineText;
//# sourceMappingURL=MagazineText.js.mapimport React from 'react';
import { PageText } from '../styles';
var MagazineText = function (_a) {
    var post = _a.post;
    return React.createElement(PageText, { type: post.style }, post.text);
};
export default MagazineText;
//# sourceMappingURL=MagazineText.js.map